module.exports = __webpack_public_path__ + "static/headerRightBg-325b5e6eda2a20d9970823bc03f7fa2f.png";